/**
 * Resolves a path relative to the public directory,
 * respecting Vite's base URL configuration.
 */

const BASE = import.meta.env.BASE_URL;

export function publicPath(path: string): string {
  const clean = path.startsWith('/') ? path.slice(1) : path;
  return `${BASE}${clean}`;
}
